import { notification } from 'antd'
import i18next from 'i18next'

import { getSharedKey } from 'utils/helpers/i18n/getKeys'

export class ValidateFormService {
  // TODO: убрать со всех валидаций второй параметр text
  hasNotErrors(errors: string[], text?: string) {
    if (errors.length > 0) {
      const singleError = errors.length === 1
      const msgs = errors.map((error, index) => <p key={index}>{(singleError ? '' : `${index + 1}. `) + `${error}`}</p>)

      notification.error({ message: i18next.t(getSharedKey('validationErrors')), description: msgs, duration: 10 })

      return false
    }

    return true
  }
}
